import { Link } from 'react-router-dom';

export default function AuditPoints() {
  const points = [
    {
      icon: 'ri-user-line',
      title: '年齢条件',
      description: '18歳以上（高校生を除く）であれば申込み可能。18歳・19歳の方は親権者の同意が必要です。'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '学生証明',
      description: '学生証や在学証明書の提出を求められる場合があります。スマホで撮影した画像でOKのカード会社が多いです。'
    },
    {
      icon: 'ri-bank-line',
      title: '銀行口座',
      description: '本人名義の銀行口座が必要です。ゆうちょ銀行やネット銀行でも問題ありません。'
    },
    {
      icon: 'ri-smartphone-line',
      title: '連絡先',
      description: '本人の携帯電話番号とメールアドレスが必要。実家の固定電話でも可能な場合があります。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '審査の傾向',
      description: '学生向けカードは収入よりも「学生である」ことが重視されます。アルバイト収入がなくても審査に通る可能性があります。'
    },
    {
      icon: 'ri-time-line',
      title: '審査期間',
      description: '最短即日〜1週間程度。オンライン申込みなら早ければ当日中にカード番号が発行されるカードもあります。'
    }
  ];

  const tips = [
    {
      title: '複数枚同時申込みは避ける',
      description: '短期間に複数のカードに申込むと「お金に困っている」と判断され、審査に不利になる可能性があります。'
    },
    {
      title: '申込み情報は正確に',
      description: '虚偽の情報を記入すると審査落ちの原因に。収入がない場合は「0円」と正直に記入しましょう。'
    },
    {
      title: '親権者の同意は事前に',
      description: '18歳・19歳の方は、申込み前に親権者に相談しておくとスムーズです。'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            審査のポイント
          </h2>
          <p className="text-lg text-gray-600">
            学生向けクレジットカードの審査で重視される項目と、通過しやすくするコツ
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {points.map((point, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-2xl border border-gray-100 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mb-4">
                <i className={`${point.icon} text-xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {point.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-orange-50 rounded-2xl p-8 md:p-12">
          <div className="flex items-start space-x-4 mb-8">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm">
              <i className="ri-lightbulb-line text-teal-600 text-2xl"></i>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                審査に通りやすくするコツ
              </h3>
              <p className="text-gray-700">
                学生向けカードは比較的審査が通りやすいですが、以下のポイントを押さえるとさらに安心です
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {tips.map((tip, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center">
                    <span className="text-xs font-bold text-teal-600">{index + 1}</span>
                  </div>
                  <h4 className="text-base font-bold text-gray-900">{tip.title}</h4>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {tip.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 bg-orange-50 border border-orange-100 rounded-2xl p-8">
          <div className="flex items-start space-x-4">
            <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-error-warning-line text-orange-600 text-xl"></i>
            </div>
            <div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">
                審査に関する注意事項
              </h4>
              <p className="text-gray-700 leading-relaxed mb-3">
                審査基準はカード会社によって異なり、必ず通過できるとは限りません。また、過去に携帯電話料金の滞納などがある場合、審査に影響する可能性があります。
              </p>
              <p className="text-sm text-gray-600">
                ※ 審査結果は個人の信用情報や申込み内容によって異なります。本記事の内容は審査通過を保証するものではありません。
              </p>
            </div>
          </div>
        </div>

        {/* 4️⃣ 限定感ブロック（キャンペーン情報） */}
        <div className="mt-12 bg-gradient-to-br from-orange-400 to-orange-500 rounded-2xl p-8 md:p-10 shadow-2xl">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-14 h-14 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
              <i className="ri-gift-line text-orange-500 text-2xl"></i>
            </div>
            <div>
              <div className="inline-block bg-white/20 backdrop-blur-sm text-white px-4 py-1 rounded-full text-sm font-bold mb-3">
                期間限定
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                今だけ！新規入会キャンペーン実施中
              </h3>
              <p className="text-white/90 text-sm md:text-base">
                対象カードに新規入会で最大25,600円相当のポイントプレゼント
              </p>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-6">
            <div className="grid md:grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-3xl font-bold text-white mb-1">最大25,600円</div>
                <div className="text-white/80 text-sm">ポイント特典</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">年会費0円</div>
                <div className="text-white/80 text-sm">永年無料</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-white mb-1">最短10秒</div>
                <div className="text-white/80 text-sm">カード番号発行</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/mitsui"
              className="inline-flex items-center justify-center gap-2 bg-white text-orange-600 font-bold px-8 py-4 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line"></i>
              詳細ページを見る
            </Link>
            <Link
              to="/ranking"
              className="inline-flex items-center justify-center gap-2 bg-orange-600 text-white font-bold px-8 py-4 rounded-xl hover:bg-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-trophy-line"></i>
              総合ランキングを見る
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium transition-colors cursor-pointer"
          >
            <i className="ri-home-line"></i>
            トップページに戻る
          </a>
        </div>
      </div>
    </section>
  );
}
